import { useMemo } from 'react';
import { QRCode } from 'react-qrcode-logo';
import { Button } from "../../Inputs";
import { Dialog } from "../Dialog/Dialog.page";
import { DialogContent } from "../Dialog/DialogContent.page";
import { ShowQRProps } from "./ShowQR.types";
import { getPartnerQrValue, getStoreQrValue } from "src/app/utils/qr-utils";

function ShowQR(props: ShowQRProps) {
  const qrValue = useMemo(() => {
    const rawValue = props.value ?? '';
    if (!rawValue) return '';
    if (props.entityType === 'store') {
      return getStoreQrValue(rawValue);
    }
    if (props.entityType === 'partner') {
      return getPartnerQrValue(rawValue);
    }
    if (props.prefix && !rawValue.startsWith(props.prefix)) {
      return `${props.prefix}${rawValue}`;
    }
    return rawValue;
  }, [props.value, props.entityType, props.prefix]);

  return (
    <Dialog
      closeOnBackdropClicked={true}
      dialogButton={<Button>{props.buttonText}</Button>}
      title={props.title}
      classNames={{ wrapper: "w-fit" }}
    >
      <DialogContent className="bg-white">
        <QRCode
          size={props.size}
          value={qrValue}
          logoImage={props.image}
          logoPadding={5}
          logoPaddingStyle='circle'
        />
      </DialogContent>
    </Dialog>
  );
}

ShowQR.defaultProps = {
  buttonText: 'Show QR',
  title: 'QR Code',
  size: 320,
  value: ''
} as ShowQRProps;

export { ShowQR };
